import client from '../client'

export const getDirectOfferInfoForSellerKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/GetDirectOfferInformationForSeller`

export async function getDirectOfferInfoForSeller({ directOfferId }) {
  const params = new URLSearchParams({ directOfferId })

  return client(`${getDirectOfferInfoForSellerKey}?${params}`)
}
